import { useTranslations } from "@zapier/i18n";
import { Icon } from "@zapier/zinnia-icons";
import { Link, Text } from "@zapier/design-system";
import styles from "./ResourceCard.module.css";
import capitalize from "lodash.capitalize";

const getIcon = (kind: Kind) => {
  switch (kind) {
    case "chatbot": {
      return "navAIChatbot";
    }
    case "zap": {
      return "miscBoltAltFill";
    }
    case "interface": {
      return "navInterfaces";
    }
    case "table": {
      return "navTables";
    }
    case "canvas": {
      return "navCanvas";
    }
    default: {
      return "miscBoltAltFill";
    }
  }
};

type Kind = "chatbot" | "zap" | "interface" | "table" | "canvas";

interface ResourceCardProps {
  kind: Kind;
  href: string;
  name: string;
}

const ResourceCard = ({ kind, href, name }: ResourceCardProps) => {
  const t = useTranslations("interface-duplicate-modal");

  return (
    <li className={styles.wrapper}>
      <Icon name={getIcon(kind)} color="BrandOrange" size={30} />
      <div className={styles.textWrapper}>
        <Text type="ParagraphHeader3">{name}</Text>
      </div>
      <Link href={href} variant="tertiary">
        {t("buttons.view-resource", { resourceType: capitalize(kind) })}
      </Link>
    </li>
  );
};

export default ResourceCard;
